var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { appear: "" }, on: { enter: _vm.onEnter, leave: _vm.onLeave } },
    [
      _vm.$props.opened
        ? _c(
            "div",
            {
              staticClass: "scid-user-bar",
              class: { "scid-user-bar--disabled": _vm.$props.disabled },
            },
            [
              _c("ScidUser"),
              _c(
                "div",
                { staticClass: "scid-user-bar__switchButton" },
                [
                  _c(
                    "BaseButton",
                    {
                      attrs: { adaptiveWidth: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onClickSwitchAccount.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("p", {
                        staticClass: "scid-user-bar__label",
                        class: {
                          "scid-user-bar__label--hidden": _vm.isLoggingOut,
                        },
                        domProps: {
                          textContent: _vm._s(_vm.$t("switch_accounts")),
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "scid-user-bar__loader" },
                        [_vm.isLoggingOut ? _c("Loader") : _vm._e()],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }